import {
  Button, ErrorMessage,
} from 'nhsuk-react-components';
import { NotifyRoutingPlan } from 'schemas/NotifyRoutingPlan.schema';
import NotifyRoutingPlansTable from './NotifyRoutingPlansTable';

interface IAdminRoutingPlansSectionProps {
  errorMessage: string;
  notifyRoutingPlans: NotifyRoutingPlan[];
  onPasteFromClipboard: () => Promise<void>;
  onDeletePlan: (plan: NotifyRoutingPlan) => void;
}

function AdminRoutingPlansSection({
  errorMessage,
  notifyRoutingPlans,
  onPasteFromClipboard,
  onDeletePlan,
}: IAdminRoutingPlansSectionProps) {
  return (
    <>
      <p>
        You can copy message plans from the NHS Notify table and paste one or more here.
      </p>
      <Button secondary onClick={onPasteFromClipboard}>
        Paste from clipboard
      </Button>
      {notifyRoutingPlans.length > 0 && (
        <>
          <p>
            {notifyRoutingPlans.length}
            {' '}
            message plan
            {notifyRoutingPlans.length > 1 ? 's' : ''}
            {' '}
            pasted in.
          </p>
          <NotifyRoutingPlansTable routingPlans={notifyRoutingPlans} onDelete={onDeletePlan} />
        </>
      )}
      {errorMessage && <ErrorMessage>{errorMessage}</ErrorMessage>}
    </>
  );
}
export default AdminRoutingPlansSection;
